import styled from 'styled-components';
import CalenderSvg from '../../assets/mytrips/calender.svg';

const CalenderIcon = styled(CalenderSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default CalenderIcon;
